import React from 'react';
import Add from './add';
import Title from '../../title';
import Loading from '../../loading';
import Server from '../../../functions/server';
import Permission from '../../../functions/permission';
import $ from "jquery";
import Upload from './upload';
import HighlightOff from '@material-ui/icons/HighlightOff';
import Equalizer from '@material-ui/icons/Equalizer';
import { Icon, Button, Form, TextArea } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CanceledInvoice from '../Receipt/canceledreceipt';

class Payments extends React.Component {

  state = {
    expenseDetail: [], fromDate: this.getFormatedDate(new Date(), 'fromDate'),
    toDate: this.getFormatedDate(new Date(), 'toDate'), fullWidth: true, maxWidth: 'sm',
    opening: 0, closing: 0, menuPermission: []
  }

  componentDidMount() {
    this.getMenuControl();
  }

  getMenuControl() {
    let menuPermission = Permission('expense', this.props.menus);
    if (menuPermission.view) {
      this.getAllExpense();
    }
    this.setState({ menuPermission })
  }

  getAllExpense() {
    let context = this;
    context.setState({ load: true })
    $.ajax({
      type: 'POST', data: { fromDate: context.state.fromDate, toDate: context.state.toDate },
      url: Server() + 'expensedetail/get.php',
      success: function(expenseDetail) {
        let opening = 0;
        let closing = 0;
        let data = [];
        try {
          expenseDetail = JSON.parse(expenseDetail);
          expenseDetail.map((c) => {
            opening = c.opening; closing = c.closing; data = c.data;
          })
          context.setState({ expenseDetail: data, opening, closing, load: false })
        } catch (e) {
          console.log(e);
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again1!!!')
      }
    });
  }

  getFormatedDate(dates, interval) {
    if (interval > 0) {
      dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month > 10) ? month : "0" + month;
    date = (date > 10) ? date : "0" + date;
    let x;
    if (interval == 'fromDate') {
      x = dates.getFullYear() + "-" + month + "-01";
    }
    else {
      x = dates.getFullYear() + "-" + month + "-" + date;
    }
    return x;
  }

  handleChange = (type) => (e, {value}) => this.setState({ [type]: value })

  convertIntoNumber(value) {
    try {
      value = Number(value);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  makeINTODecimal(value) {
    try {
      value = value.toFixed(2);
    } catch (error) {
      value = '';
    }
    return value;
  }

  openStatusChange(expenseId) {
    if (!this.state.menuPermission.edit) {
      alert('You Are Not Allow To Edit Status!!!');
      return;
    }
    this.setState({ expenseId, openApproveDialog: true })
  }

  approveOrRejectExpense(status) {
    let context = this;
    let { expenseId } = this.state;
    $.ajax({
      type: 'POST', data: { status, expenseId },
      url: Server() + 'expensedetail/changestatus.php',
      success: function(data) {
        if (data == 1) {
          let expenseDetail = context.state.expenseDetail;
          expenseDetail.map((c) => {
            if (c.id == expenseId) {
              c.status = status+'';
            }
          })
          context.setState({ openApproveDialog: false, expenseDetail })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again2!!!')
      }
    });
  }


  cancel() {
    let context = this;
    $.ajax({
      type: 'POST', data: { 'id': context.state.cancelId, 'reason': context.state.reason },
      url: Server() + 'expensedetail/cancel.php',
      success: function(data) {
        if (data == 1) {
          context.getAllExpense();
          context.setState({ cancelDilog: false })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again3!!!')
      }
    });
  }

  handleChange1 = name => event => {
    this.setState({ [name]: event.target.value })
  }

  render() {
    let sino = 1;
    let closingBalance = 0;
    return (
      <div>
        <Title title={'Expense'} openDrawer={this.props.openDrawer}/>
        <Loading load={this.state.load} message={this.state.message} />
        { this.state.menuPermission.view ?
          (
            <div style={{margin: 10}}>
              <div style={{display: 'flex'}}>
                <div style={{marginLeft: 5}}>
                  From Date<br/>
                  <input type="date" id="date" value={this.state.fromDate}
                  style={{height: 35 }} onChange={ (event) => { this.setState({ fromDate: event.target.value }) }} />
                </div>
                <div style={{marginLeft: 5}}>
                    To Date<br/>
                    <input type="date" id="date" value={this.state.toDate}
                    style={{height: 35 }} onChange={ (event) => { this.setState({ toDate: event.target.value }) }} />
                </div>
                <div style={{marginLeft: 5}}>
                    <br/>
                    <Button onClick={this.getAllExpense.bind(this)}>Submit</Button>
                </div>
                <div style={{marginLeft: 5}}>
                  <br/>
                  { this.state.menuPermission.add ?
                    (<Add getAllExpense={this.getAllExpense.bind(this)} />):''
                  }
                </div>
                <div style={{marginLeft: 5}}>
                  <br/>
                  <CanceledInvoice name={'Cancelled Expense'} type="Expense" />
                </div>
              </div>
              <div style={{marginTop: 2}}>
                <div style={{display: 'flex', width: '100%'}}>
                  <div style={{textAlign: 'left', width: '50%', fontSize: '18px'}}>{'Opening Balance: '+this.makeINTODecimal(this.convertIntoNumber(this.state.opening))}</div>
                  <div style={{textAlign: 'right', width: '50%', fontSize: '18px'}}>{'Closing Balance: '+this.makeINTODecimal(this.convertIntoNumber(this.state.closing))}</div>
                </div>
                <table width="100%" id="table">
                  <tr>
                    <th id="th">Sino</th>
                    <th id="th" style={{width: '8%'}}>Payment Date</th>
                    <th id="th">Voucher</th>
                    <th id="th">HSN Code</th>
                    <th id="th">Expense</th>
                    <th id="th">Payment Mode</th>
                    <th id="th">Branch</th>
                    
                    <th id="th">Whom</th>
                    <th id="th">Name</th>
                    <th id="th">Tax</th>
                    <th id="th">Credit</th>
                    <th id="th">Debit</th>
                    <th id="th" style={{display: 'none'}}>Closing</th>
                    <th id="th">Upload</th>
                    <th id="th">Status</th>
                    <th id="th">Cancel</th>
                  </tr>
                  {
                    this.state.expenseDetail.map((c) => {
                      let amount = this.convertIntoNumber(c.amount);
                      let creditAmount = '';
                      let debitAmount = '';
                      let icon = (<Equalizer style={{color: '#406FCF'}} onClick={this.openStatusChange.bind(this, c.id)} />);
                      if (c.status == '2') {
                        icon = (<HighlightOff style={{color: 'red'}} />);
                      }
                      if (c.status == '1') {
                        icon = (<Icon name='check circle' style={{color: 'green'}} size='large' />);
                      }
                      if (amount > 0) { creditAmount = amount; closingBalance = closingBalance + amount; }
                      else { debitAmount = (amount * -1); closingBalance = closingBalance - (amount * -1); }
                      return (
                        <tr>
                          <td>{sino++}</td>
                          <td><center>{c.payment_date}</center></td>
                          <td>{c.voucher}</td>
                          <td>{c.hsncode}</td>
                          <td><b>{c.expense_master}</b></td>
                          <td>{c.mode}</td>
                          <td>{c.branch}</td>
                          <td>{c.whom}</td>
                          <td>{c.name}</td>
                          <td>{c.tax}</td>
                          <td><div style={{textAlign: 'right'}}>{this.makeINTODecimal(creditAmount)}</div></td>
                          <td><div style={{textAlign: 'right'}}>{this.makeINTODecimal(debitAmount)}</div></td>
                          <td style={{display: 'none'}}>
                            { closingBalance > 0 ? closingBalance : (closingBalance * -1) }
                          </td>
                          <td><center><Upload menuPermission={this.state.menuPermission} id={c.id} files={c.count} /></center></td>
                          <td>
                            <center>
                              {icon}
                            </center>
                          </td>
                          <td onClick={ () => 
                            { 
                              if (!this.state.menuPermission.cancel) {
                                alert('You Are Not Allow To Cancel!!!');
                                return;
                              }
                              this.setState({ cancelId: c.id, cancelDilog: true }) 
                            }}>
                            <center style={{color: 'red', fontWeight: 'bold'}}>Cancel</center>
                          </td>
                        </tr>
                      )
                    })
                  }
                </table>
              </div>
            </div>
          ):
          (
            <center>You Are Not Allow To Access This Menu!!!</center>
          )

        }
        

        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth} open={this.state.openApproveDialog}
          onClose={ () => { this.setState({ openApproveDialog: false }) }}
          aria-labelledby="max-width-dialog-title" >
          <DialogTitle id="max-width-dialog-title">Confirmation</DialogTitle>
            <DialogContent>
              <div style={{padding: '3%'}}>
                Confirmation to this expence 
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={ () => { this.setState({ openApproveDialog: false }) }} color="primary">Close</Button>
              <Button color="primary" onClick={this.approveOrRejectExpense.bind(this, 2)}>Rejected</Button>
              <Button color="primary" onClick={this.approveOrRejectExpense.bind(this, 1)}>Approve</Button>
            </DialogActions>
        </Dialog>


        <Dialog fullWidth={true} maxWidth={'sm'}
          open={this.state.cancelDilog} onClose={ () => { this.setState({ cancelDilog: false }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Reason</DialogTitle>
          <DialogContent>
              Reason<br/>
              <Form>
                <TextArea value={this.state.remark} onChange={this.handleChange1('reason')} fluid />
              </Form>
          </DialogContent>
          <DialogActions>
               <Button onClick={  () => { this.setState({ cancelDilog: false }) } }>Close</Button> 
               <Button onClick={this.cancel.bind(this)}>Submit</Button> 
          </DialogActions>
        </Dialog>

      </div>
    );
  }
}

export default Payments;
